import { useAuth } from "react-oidc-context";
import * as React from 'react';

declare const rootUrl: string;

export const Unauthorized = () => {
    const { user, signoutRedirect } = useAuth();

    const signOut = () => {
        signoutRedirect({ post_logout_redirect_uri: `${rootUrl}spa/account/signedout` });
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="wrapper wrapper-content">
                    <div className="errorscreen middle-box text-center animated fadeInDown">
                        <h1 className="logo-name">
                            <img src="/Content/Images/Misc/vitalograph-logo.png" alt="" />
                        </h1>
                        <h3 className="font-bold">Unauthorized</h3>
                        <div className="error-desc">
                            You do not have the required credentials to access to this page. Your account may be disabled. Please contact Vitalograph at <a href="mailto:websupport@vitalograph.co.uk">websupport@vitalograph.co.uk</a> if this is unexpected
                        </div>
                        <a className="btn btn-primary btn-block" href="/" style={{ marginTop: 25 + 'px' }}>Return to Home</a>
                        {user ? <a className="btn btn-primary btn-outline btn-block" onClick={signOut} style={{ marginTop: 25 + 'px' }}>Sign out</a> : null}
                    </div>
                </div>
            </div>
        </div>
    );
}
